import { apiRequest } from "./interceptor";

// Chat APIs
const getVendorConversation = (receiverId) => apiRequest("get", `/chat/getConversation?receiverId=${receiverId}&role=vendor`);
const updateVendorConversationStatus = (conversationId, status) => apiRequest("put", `/chat/update-status?conversationId=${conversationId}&status=${status}`);



// Exporting functions to be used
export default {
  getVendorConversation,
  updateVendorConversationStatus,
};
